import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';
import {hasAccessToScopeByApplication} from 'Shared/utilities/applicationId';
import {Scope} from 'Shared/constants/Scope';
import {Application} from 'Users/models/Application';
import {Paper, IconButton, MenuItem} from '@material-ui/core';
import {removeUserType, changeAppEntryRole} from 'Users/ducks/userEntry';
import {Close} from '@material-ui/icons';
import OutlinedSelect from 'Shared/components/OutlinedSelect';
import {AppEntryUserType, AppEntryRole} from 'Users/models/User/AppEntryUserType';

type AppEntryUserTypeEntryProps = {
  appEntryUserType: AppEntryUserType;
  isEdit: boolean;
};

const AppEntryUserTypeEntry = (props: AppEntryUserTypeEntryProps) => {
  const dispatch = useDispatch();
  const {appEntryUserType} = props;

  const scopes = useSelector(selectUserScopes);
  const hasUpdateAccess = hasAccessToScopeByApplication(scopes, Scope.UpdateUser, Application.AppEntry);

  return (
    <Paper className="bos-tools-user-type-entry">
      <IconButton
        className="bos-tools-user-type-entry__remove-button"
        onClick={() => dispatch(removeUserType(appEntryUserType))}
        disabled={!hasUpdateAccess && props.isEdit}
      >
        <Close />
      </IconButton>
      <p className="bos-tools-user-type-entry__title">App Entry Permissions</p>
      <p className="bos-tools-user-type-entry__description">Select a role to add App Entry permissions to this user.</p>
      <OutlinedSelect
        className="bos-tools-user-type-entry__role-select"
        label="App Entry Role"
        value={appEntryUserType.value.appEntryRole || ''}
        onChange={e => dispatch(changeAppEntryRole(parseInt(e.target.value, 10) as AppEntryRole))}
        disabled={!hasUpdateAccess && props.isEdit}
      >
        <MenuItem value={AppEntryRole.Keyer}>Keyer</MenuItem>
      </OutlinedSelect>
    </Paper>
  );
};

export default AppEntryUserTypeEntry;
